import SocioService from '../../services/SocioService'

const state = () => ({
    dadosComercial: {
        id: null,
        SocioId: null,
        firstName: '',
        lastName: '',
        clinica: '',
        telefone_1: '',
        telefone_2: '',
        telefone_wp: '',
        rqe: null,
        zip: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        country: '',
        check_divulgation: false,
        especialista: false,
        termosCondic: false,
        check_adm: 'pendente',
        status: 'ativo',
        latitude: null,
        longitude: null,
    },
    loadingComercial: false,
})
  
const mutations = {
    SET_DADOS_COMERCIAL: (state, payload) => {
        state.dadosComercial = payload;
    },
    SET_LOADING_COMERCIAL: (state, payload) => {
        state.loadingComercial = payload
    },
}

const actions = {
    async setDadosComerciais({commit, state, rootState}){
        try {
            commit('SET_LOADING_COMERCIAL', true)
            const formData = new FormData();
            const dadosFormulario = { ...state.dadosComercial };
            const rqeFile = dadosFormulario.rqe instanceof File ? dadosFormulario.rqe : null;

            if (rqeFile) {
                formData.append('rqe', rqeFile);
                dadosFormulario.rqe = null;
            }

            formData.append('firstName', rootState.user.user.firstName || dadosFormulario.firstName || '');
            formData.append('lastName', rootState.user.user.lastName || dadosFormulario.lastName || '');
            formData.append('dadosFormularios', JSON.stringify(dadosFormulario));

            const response = await SocioService.setDadosComerciais(formData);

            if (response.data.dadosComercial) {
                commit('SET_DADOS_COMERCIAL', response.data.dadosComercial);
            }

            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_COMERCIAL', false)
        } catch (error) {
            commit('SET_LOADING_COMERCIAL', false)
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao salvar dados comerciais.'
            });
        }
    },
}

const getters = {
    getDadosComercial: state => state.dadosComercial,
    getLoadingComercial: state => state.loadingComercial
}

export default {
    state,
    getters,
    mutations,
    actions
};